import { render, staticRenderFns } from "./RemoteOrder.vue?vue&type=template&id=1b0f5000&scoped=true"
import script from "./RemoteOrder.vue?vue&type=script&lang=js"
export * from "./RemoteOrder.vue?vue&type=script&lang=js"
import style0 from "./RemoteOrder.vue?vue&type=style&index=0&id=1b0f5000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0f5000",
  null
  
)

export default component.exports